import { PersonInfo } from "@/components/ui";
import useChannel from "@/hooks/useChannel";
import { genChannelName } from "@/libraries/helper";
import type { ContactMember } from "@/types";
import MessageIcon from "@mui/icons-material/Message";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import { Link, useNavigate } from "@tanstack/react-router";

interface ContactCardProps {
	member: ContactMember;
	size: number;
	start: number;
	isMe?: boolean;
}

const ContactCard = (props: ContactCardProps) => {
	const { member, size, start, isMe = false } = props;
	const navigate = useNavigate();
	const { mutateCreateChannel } = useChannel();
	const memberFullName = String(
		member.fullname ?? member.first_name ?? member.last_name,
	);

	const onClickMessage = async (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		let channelName = member.channel_name;
		if (!channelName) {
			const resNewChannel = await mutateCreateChannel.mutateAsync({
				name: genChannelName("single"),
				messageable_id: member.id.toString(),
				messageable_type: "User",
			});
			channelName = resNewChannel.user.channel_name;
		}
		return navigate({
			to: "/dashboard/chat/single/$id/$channelName",
			params: { id: member.id, channelName },
		});
	};

	return (
		<Link
			to="/dashboard/contacts/member/$id"
			params={{ id: member.id.toString() }}
			className="container absolute top-0 left-0"
			style={{
				height: size,
				transform: `translateY(${start}px)`,
			}}
		>
			<Card variant="outlined" className="!w-full !h-full !rounded-xl">
				<div className="flex justify-between items-center p-4 h-full">
					<PersonInfo
						avatar={member.avatar}
						fullName={memberFullName}
						hospitalName={member.hospital?.name}
						jobTitle={member.job_title}
						status={member.status}
						isMe={isMe}
					/>
					{!isMe ? (
						<IconButton
							color="primary"
							aria-label="message"
							size="large"
							onClick={onClickMessage}
						>
							<MessageIcon color="primary" />
						</IconButton>
					) : null}
				</div>
			</Card>
		</Link>
	);
};

export default ContactCard;
